export default {
  baseUrl: "https://omang2-api.cubettech.in",
  portalUrl: "https://omang2.cubettech.in",
  productionUrl: "https://omang.odineducation.net",
  imageUpload: "https://odin-parentapp.cubettech.in"
};
export const qbAdminId = "133330163";

const siteConfig = {
  siteName: "Omang",
  siteIcon: "ion-flash",
  footerText: "Omang ©2020",
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";
export { siteConfig, language, themeConfig };
